export default "__VITE_ASSET__6JMmdu5W__"